import { Injectable } from '@angular/core';
import * as _ from 'lodash';

import { Machine } from '../models/machine';

// Dummy MachineRegistry service
// Just for frontend development usage, replace with machines.service

 // REMOVE
@Injectable()
export class MachineRegistryService {

    public machines: Array<Machine> = [
        {
            serialNumber: '123456',
            productId: 'X8100501100',
            productName: 'X8 POWER SOURCE 500 MV, COOLER',
            secureId: '1234',
            manufactureDate: '2017-01-01T12:00:00.000',
            deliveryDate: '2017-06-01T12:00:00.000',
            warrantyExpireDate: '2020-06-11T12:00:00.000',
            warrantyState: 'AUTOMATIC',
            transactions: [
                {
                    transferId: 'MFG-STK',
                    company: '100',
                    orderNumber: null,
                    shipNumber: null,
                    jobNumber: '100001',
                    stock: 'HUB',
                    partnerId: null,
                    partnerName: null,
                    transferDate: '2017-01-01T12:00:00.000',
                    updateDate: '2017-01-01T12:00:00.000',
                    insertDate: '2017-01-01T12:00:00.000',
                    customerGroupCode: null
                },
                {
                    transferId: 'STK-CUS',
                    company: '100',
                    orderNumber: '800000',
                    shipNumber: '123456',
                    jobNumber: '100002',
                    stock: 'HUB',
                    partnerId: '130',
                    partnerName: 'KEMPPI SVERIGE AB',
                    transferDate: '2017-05-01T12:00:00.000',
                    updateDate: '2017-05-01T12:00:00.000',
                    insertDate: '2017-05-01T12:00:00.000',
                    customerGroupCode: 'E'
                },
                {
                    transferId: 'DRP-CUS',
                    company: '130',
                    orderNumber: '999333',
                    shipNumber: null,
                    jobNumber: 'K22000',
                    stock: null,
                    partnerId: 'SE037000',
                    partnerName: 'TOOLS SVERIGE AB',
                    transferDate: '2017-06-01T12:00:00.000',
                    updateDate: '2017-06-01T12:00:00.000',
                    insertDate: '2017-06-01T12:00:00.000',
                    customerGroupCode: 'B2'
                }
            ],
            registration: {
                company: '100',
                partnerId: 'FI01000',
                partnerName: 'Suorakaiteet Oy',
                salesDate: '2018-06-11T12:00:00.000',
                registrationDate: '2018-06-11T12:00:00.000'
            },
            endCustomerRegistration: {
                tenantId: '1234-5678-1234-5678-12345678-0', // Auth0 company id
                name: 'Loppuasiakas Oy',
                registrationDate: '2018-06-15T12:00:00.000'
            },
            version: {
                created: {
                    timestamp: '2018-05-04T12:00:00.000',
                    user: {
                        id: 'system-integration',
                        name: 'ERP integration'
                    }
                },
                modified: {
                    timestamp: '2018-05-04T12:00:00.000',
                    user: {
                        id: 'system-integration',
                        name: 'ERP integration'
                    }
                }
            }
        },
        {
            serialNumber: '222222',
            productId: '6413230',
            productName: 'KEMPACT 323A',
            secureId: '1234',
            manufactureDate: '2015-01-01T12:00:00.000',
            deliveryDate: '2015-06-01T12:00:00.000',
            warrantyExpireDate: '2017-06-11T12:00:00.000',
            warrantyState: 'AUTOMATIC',
            transactions: [
                {
                    transferId: 'MFG-STK',
                    company: '100',
                    orderNumber: null,
                    shipNumber: null,
                    jobNumber: '100001',
                    stock: 'HUB',
                    partnerId: null,
                    partnerName: null,
                    transferDate: '2015-01-01T12:00:00.000',
                    updateDate: '2015-01-01T12:00:00.000',
                    insertDate: '2015-01-01T12:00:00.000',
                    customerGroupCode: null
                },
                {
                    transferId: 'STK-CUS',
                    company: '100',
                    orderNumber: '800000',
                    shipNumber: '123456',
                    jobNumber: '100002',
                    stock: 'HUB',
                    partnerId: '130',
                    partnerName: 'KEMPPI SVERIGE AB',
                    transferDate: '2015-05-01T12:00:00.000',
                    updateDate: '2015-05-01T12:00:00.000',
                    insertDate: '2015-05-01T12:00:00.000',
                    customerGroupCode: 'E'
                },
                {
                    transferId: 'DRP-CUS',
                    company: '130',
                    orderNumber: '999333',
                    shipNumber: null,
                    jobNumber: 'K22000',
                    stock: null,
                    partnerId: 'SE037000',
                    partnerName: 'TOOLS SVERIGE AB',
                    transferDate: '2015-06-01T12:00:00.000',
                    updateDate: '2015-06-01T12:00:00.000',
                    insertDate: '2015-06-01T12:00:00.000',
                    customerGroupCode: 'B2'
                }
            ],
            registration: {
                company: '100',
                partnerId: 'FI01000',
                partnerName: 'Suorakaiteet Oy',
                salesDate: '2015-06-11T12:00:00.000',
                registrationDate: '2015-06-11T12:00:00.000'
            },
            version: {
                created: {
                    timestamp: '2015-05-04T12:00:00.000',
                    user: {
                        id: 'system-integration',
                        name: 'ERP integration'
                    }
                },
                modified: {
                    timestamp: '2015-05-04T12:00:00.000',
                    user: {
                        id: 'system-integration',
                        name: 'ERP integration'
                    }
                }
            }
        },
        {
            serialNumber: '112233',
            productId: '6150500CA',
            productName: 'FASTMIG PULSE 450 STX FRANCE',
            secureId: '1234',
            manufactureDate: '2017-01-01T12:00:00.000',
            deliveryDate: null,
            warrantyExpireDate: '2020-06-11T12:00:00.000',
            warrantyState: 'MANUAL',
            transactions: [
                {
                    transferId: 'MFG-STK',
                    company: '100',
                    orderNumber: null,
                    shipNumber: null,
                    jobNumber: '100001',
                    stock: 'HUB',
                    partnerId: null,
                    partnerName: null,
                    transferDate: '2017-01-01T12:00:00.000',
                    updateDate: '2017-01-01T12:00:00.000',
                    insertDate: '2017-01-01T12:00:00.000',
                    customerGroupCode: null
                }
            ],
            registration: null,
            version: {
                created: {
                    timestamp: '2018-05-04T12:00:00.000',
                    user: {
                        id: 'system-integration',
                        name: 'ERP integration'
                    }
                },
                modified: {
                    timestamp: '2018-05-04T12:00:00.000',
                    user: {
                        id: 'system-integration',
                        name: 'ERP integration'
                    }
                }
            }
        }
    ];

    constructor() { }

    getLatest() {
        return this.machines;
    }

    getSerialInfo(serialNumber) {
        const machineInfo: any = _.find(this.machines, { serialNumber: serialNumber });
        return machineInfo;
    }
}
